import React from "react";
import Validator from "validator";
import Recaptcha from "react-recaptcha";

class Member extends React.Component {

    state = {
        fields: {
            email: "",
            formName: "",
            number: "",
            company: ""
        },
        errors: {}
    };


    onChange = e =>
      this.setState({
          fields: {...this.state.fields, [e.target.name]: e.target.value}
      });

    onSubmit = e => {
        e.preventDefault();
        const errors = this.validate(this.state.fields);
        this.setState({errors});
        if (Object.keys(errors).length === 0) {
            this.setState({loading: true});
            this.props
              .submit(this.state.fields)
        }
    };

    validate = fields => {
        const errors = {};
        if (!Validator.isEmail(fields.email)) errors.email = "Please enter a valid email";
        if (!fields.formName) errors.formName = "Please enter name";
        if (!fields.number) errors.number = "Please enter a phone number we can contact you with";
        if (!fields.company) errors.company = "Please enter your company / organisation";
        return errors;
    };

    render() {
        const {fields, errors} = this.state;
        return <div className={this.props.active}>
            <div className="member">
                <div className="rob-list__title  rob-list__title--modal"><h2>Become a Member</h2></div>
                <div>
                    <form acceptCharset="UTF-8" onSubmit={this.onSubmit}>
                        <input type="hidden" name="action" value="guest-entries/save"/>
                        <input type="hidden" name="sectionUid" value="ccba3c1a-0d7e-4af1-b92d-c36e8d21b358"/>

                        <div className="row">
                            <div className="col-12">
                                <div className={
                                    errors.formName ? "rob-form-group rob-form-error" : "rob-form-group"
                                }>
                                    <input type="text" name="formName"
                                           placeholder="Name*"
                                           value={fields.formName}
                                           className="rob-input-text"
                                           onChange={this.onChange}
                                           maxLength="50"/>
                                    <small className="rob-input-text--error__message">{errors.formName}</small>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className={
                                    errors.email ? "rob-form-group rob-form-error" : "rob-form-group"
                                }>
                                    <input type="text" name="email"
                                           placeholder="Email*"
                                           className="rob-input-text"
                                           value={fields.email}
                                           onChange={this.onChange}
                                           maxLength="50"/>
                                    <small className="rob-input-text--error__message">{errors.email}</small>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className={
                                    errors.number ? "rob-form-group rob-form-error" : "rob-form-group"
                                }>
                                    <input type="text"
                                           name="number"
                                           value={fields.number}
                                           onChange={this.onChange}
                                           placeholder="Phone number*"
                                           className="rob-input-text"/>
                                    <small className="rob-input-text--error__message">{errors.number}</small>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className={
                                    errors.company ? "rob-form-group rob-form-error" : "rob-form-group"
                                }>
                                    <input type="text"
                                           name="company"
                                           value={fields.company}
                                           onChange={this.onChange}
                                           placeholder="Company / Organisation*"
                                           className="rob-input-text"/>
                                    <small className="rob-input-text--error__message">{errors.company}</small>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="rob-form__recaptcha">
                                    <Recaptcha
                                      sitekey="6LfNR28UAAAAAIHs3-DwlmUgdHo0U4oNckk3UHZb"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 sib-contact__submit">
                                <button type="submit" value="Submit"
                                        className="button button-primary">
                                    Submit
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    }
};
Member.defaultProps = {active: []};
export default Member


// WEBPACK FOOTER //
// ./src/components/elements/modals/Member.js